module.exports = __webpack_public_path__ + "img/solar_trash-bin-2-outline.70c1c463.svg";